<template>
  <span class="history-date tw:block">
    <b class="history-date__date tw:block tw:min-h-4.5 tw:wrap-anywhere">{{
      DateUtils.formatServerDateTime(
        value,
        DateUtils.getClientDateTimeConfig().dayMonthShort,
        locale,
      )
    }}</b>
    <small
      v-if="showTime"
      class="history-date__time tw:block tw:mt-0.5 tw:type-meta tw:wrap-anywhere tw:text-(--muted-foreground)"
      >{{
        DateUtils.formatServerDateTime(
          value,
          DateUtils.getClientDateTimeConfig().hourMinute,
          locale,
        )
      }}</small
    >
  </span>
</template>
<script setup>
// 1. Import necessary components
import { useI18n } from 'vue-i18n';
import DateUtils from '@/shared/utilities/date-utils';
// 2. Use
defineProps({
  value: { type: String, required: true },
  showTime: { type: Boolean, default: false },
});
const { locale } = useI18n();
// 3. Define a reactive variable
// 4. Define methods or computed properties if needed
// 5. VueJS Hooks
</script>
